/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { HealthCard } from './HealthCard';
import {
    HealthCardFromJSON,
    HealthCardFromJSONTyped,
    HealthCardToJSON,
} from './HealthCard';

/**
 * 
 * @export
 * @interface PatientByStaffRegisterPayload
 */
export interface PatientByStaffRegisterPayload {
    /**
     * 
     * @type {string}
     * @memberof PatientByStaffRegisterPayload
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof PatientByStaffRegisterPayload
     */
    email: string;
    /**
     * 
     * @type {HealthCard}
     * @memberof PatientByStaffRegisterPayload
     */
    health_card?: HealthCard;
    /**
     * 
     * @type {string}
     * @memberof PatientByStaffRegisterPayload
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientByStaffRegisterPayload
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientByStaffRegisterPayload
     */
    gender?: PatientByStaffRegisterPayloadGenderEnum;
    /**
     * 
     * @type {number}
     * @memberof PatientByStaffRegisterPayload
     */
    date_of_birth?: number;
}


/**
 * @export
 */
export const PatientByStaffRegisterPayloadGenderEnum = {
    Male: 'Male',
    Female: 'Female'
} as const;
export type PatientByStaffRegisterPayloadGenderEnum = typeof PatientByStaffRegisterPayloadGenderEnum[keyof typeof PatientByStaffRegisterPayloadGenderEnum];


/**
 * Check if a given object implements the PatientByStaffRegisterPayload interface.
 */
export function instanceOfPatientByStaffRegisterPayload(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "phone" in value;
    isInstance = isInstance && "email" in value;

    return isInstance;
}

export function PatientByStaffRegisterPayloadFromJSON(json: any): PatientByStaffRegisterPayload {
    return PatientByStaffRegisterPayloadFromJSONTyped(json, false);
}

export function PatientByStaffRegisterPayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatientByStaffRegisterPayload {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'phone': json['phone'],
        'email': json['email'],
        'health_card': !exists(json, 'health_card') ? undefined : HealthCardFromJSON(json['health_card']),
        'first_name': !exists(json, 'first_name') ? undefined : json['first_name'],
        'last_name': !exists(json, 'last_name') ? undefined : json['last_name'],
        'gender': !exists(json, 'gender') ? undefined : json['gender'],
        'date_of_birth': !exists(json, 'date_of_birth') ? undefined : json['date_of_birth'],
    };
}

export function PatientByStaffRegisterPayloadToJSON(value?: PatientByStaffRegisterPayload | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'phone': value.phone,
        'email': value.email,
        'health_card': HealthCardToJSON(value.health_card),
        'first_name': value.first_name,
        'last_name': value.last_name,
        'gender': value.gender,
        'date_of_birth': value.date_of_birth,
    };
}

